import { defineStore } from "pinia";
import { reactive } from "vue";

export type TFeatureFlag =
  | "app.insights"
  | "ui.user.pools.beta"
  | "user.app.ask.momentum"
  | "generic-ui-flag"
  | "app.scheduled-notifications.run-every-minute"
  | "ai.summary.action.buttons"
  | "dataInsight.reasonField"
  | "app.migration.from.using.jsonEditor.in.wizard"
  | "user.flow.filter.logic"
  | "ui.spotless.config";

export const useLaunchDarklyStore = defineStore("launchDarkly", () => {
  const ldFlags = reactive({
    flags: {} as Record<TFeatureFlag, boolean>,
  });

  function setFlags(flags: Record<TFeatureFlag, boolean>) {
    ldFlags.flags = flags;
  }

  return { ldFlags, setFlags };
});
